// Angular modules
import { Component }        from '@angular/core';

// Ionic modules
import { GoogleAnalytics }  from '@ionic-native/google-analytics';
import { NavController }    from 'ionic-angular';
import { ModalController }  from 'ionic-angular';
import { NavParams }        from 'ionic-angular';
import { MenuController }   from 'ionic-angular';
import { ToastController }  from 'ionic-angular';

// External modules
import { Product }          from '../../shared/models/product';
import { CartService }      from '../../shared/providers/cart-service';
import { AddToCartPage }    from '../add-to-cart/add-to-cart';
import { ContactPage }      from '../contact/contact';
import { KeyPointsPage }    from '../key-points/key-points';
import { TranslateService } from '@ngx-translate/core';

// Interfaces
import { Image }            from '../../shared/interfaces/image.interface';

// Helpers
import { IndexedDbHelper }  from '../../shared/helpers/indexed-db.helper';


@Component({
  selector: 'page-product-detail',
  templateUrl: 'product-detail.html'
})

export class ProductDetailPage
{
  product : Product = null;
  images  : Map<string, Image> =  new Map();

  constructor(public navCtrl     : NavController,
              public toastCtrl   : ToastController,
              public navParams   : NavParams,
              public menuCtrl    : MenuController,
              public cartService : CartService,
              public modalCtrl   : ModalController,
              public t           : TranslateService,
              private analytics  : GoogleAnalytics)
  {
    this.product      = this.navParams.data;

    if(this.product.LimitingFactors != null)
      this.product.LimitingFactors = this.product.LimitingFactors.replace(",", '<br/>')

    if(this.product.TypeOfFilm != null)
      this.product.TypeOfFilm = this.product.TypeOfFilm.replace(",", '<br/>')

    if(this.product.Country != null)
      this.product.Country = this.product.Country.replace(",", '<br/>')

    this.updateAligalLabel();
    this.updateOxygeneLabel();
  }

  async ionViewDidLoad()
  {
    this.analytics.trackView("Product result " + this.product.OriginalName);

    const keys = await IndexedDbHelper.getImageKeys();
    for (const key of keys)
    {
      const image = await IndexedDbHelper.getImage(key);
      this.images.set(key, image);
    }
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  updateAligalLabel()
  {
    if(this.product.ALIGAL.indexOf("ALIGAL") == -1)
      return;

    if(this.product.ALIGAL == null)
      return;

    var tab  = this.product.ALIGAL.split(" ");

    if(this.product.ALIGAL.indexOf('™ ') > -1)
      return;

    if(tab.length > 1)
      this.product.ALIGAL = tab[0] + '™ ' + tab[1]
    else
      this.product.ALIGAL = tab[0] + '™ '
  }

  updateOxygeneLabel()
  {
    if(this.product.OxygenLevel == null)
      return;

    if(this.product.OxygenLevel.indexOf('%') > -1)
      return;

    this.product.OxygenLevel = this.product.OxygenLevel + ' %';
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }

  addToCart()
  {
    let profileModal = this.modalCtrl.create(AddToCartPage, this.product);
    profileModal.present();
  }

  goToComsuption()
  {
    this.navCtrl.push(KeyPointsPage,{}, {animate: false});
  }

  presentToast(message)
  {
     let toast = this.toastCtrl.create({
       message: message,
       duration: 3000
     });
     toast.present();
  }

  goToContact()
  {
    this.navCtrl.push(ContactPage,{}, {animate: false});
  }

  getImageByName(name: string): string
  {
    name = name.trim().toLocaleLowerCase();
    if(this.images.has(name))
      return this.images.get(name).Content;

    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/product-detail/product-detail.ts